module.exports = __webpack_public_path__ + "media/images/ninestars/clients/client-3-a3b2ef65c008e5a86e2e121163e455a6.png";